import { ErrorToast } from 'components/Toasts/Toasts';
import React, { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import { CaptionText, Div, ImageUploadIcon, P2, colors } from 'styles';

const UploadContainer = styled.div`
  width: 100%;
  margin: auto;
  margin-bottom: 20px;
  text-align: center;
`;

const DropBox = styled.div`
  width: 150px;
  height: 150px;
  /* border: 2px dashed ${({ theme }) => theme.gray}; */
  display: flex;
  align-items: center;
  justify-content: center;
  /* cursor: pointer; */
  transition: 0.3s;
  border-radius: 8px;
  position: relative;

  background: radial-gradient(
      158.48% 294.91% at 50% 320.96%,
      rgba(0, 204, 240, 0.98) 0%,
      rgba(0, 208, 240, 0) 100%
    ),
    linear-gradient(0deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1));

  border: 1px solid ${({ theme }) => theme.gray}4c;
  box-shadow: 0px 70.82px 130.86px 0px rgba(0, 0, 0, 0.1);
  /* background: #fafafa; */

  /* &:hover {
    background: #f0f0f0;
  } */
`;

const HiddenInput = styled.input`
  display: none;
`;

const ImagePreviewContainer = styled.div`
  display: flex;
  justify-content: center;
  /* margin-top: 10px; */
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  overflow: hidden;
  /* border: 2px solid #ddd; */
`;

const PreviewImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
`;

const RemoveButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(255, 0, 0, 0.7);
  border: none;
  color: white;
  cursor: pointer;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ProfileUpload = ({
  image,
  setImage,
}: {
  image: File | null;
  setImage: Dispatch<SetStateAction<File | null>>;
}) => {
  const handleFiles = (newFiles: FileList | null) => {
    if (!newFiles || newFiles.length === 0) return;
    const selectedFile = newFiles[0];

    if (!selectedFile.type.startsWith('image/')) {
      ErrorToast('Only images are allowed.');
      return;
    }

    setImage(selectedFile);
  };

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    handleFiles(event.dataTransfer.files);
  };

  const removeImage = () => {
    setImage(null);
  };

  return (
    <UploadContainer>
      <DropBox
        onDragOver={(event) => event.preventDefault()}
        onDrop={handleDrop}
      >
        {image ? (
          <ImagePreviewContainer
            onClick={() => document.getElementById('profileInput')?.click()}
          >
            <ImageWrapper>
              <PreviewImage
                src={URL.createObjectURL(image)}
                alt='Profile Preview'
              />
            </ImageWrapper>
          </ImagePreviewContainer>
        ) : (
          <Div
            $pointer
            onClick={() => document.getElementById('profileInput')?.click()}
          >
            <ImageUploadIcon />
            <CaptionText color='#8B96AA' m='5px 10px 0px'>
              Drag & Drop image or Click to Upload
            </CaptionText>
          </Div>
        )}
        {image && <RemoveButton onClick={removeImage}>✖</RemoveButton>}
      </DropBox>

      <HiddenInput
        id='profileInput'
        type='file'
        accept='image/*'
        onChange={(event) => handleFiles(event.target.files)}
      />
    </UploadContainer>
  );
};
